import { useAtom } from "jotai";
import React from "react";
import { MenuItem } from "../components/Menu";
import { currentUserAtom } from "../jotai/atoms";
import { MapClient } from "@roomservice/react";
import { AnyBlock } from "../types";
import { ROOM_SERVICE_MAP_KEYS } from "../consts";
import { useRoomClient } from "../roomservice/utils";

export default function ExportText() {
  const [currentUser] = useAtom(currentUserAtom);
  const room = useRoomClient();

  if (!currentUser) return null;

  let exportText = () => {
    if (!room) return;
    const bIds: MapClient<Record<string, string>> = room.map(
      ROOM_SERVICE_MAP_KEYS.BLOCKIDS
    );
    let allText = "";

    for (let index in bIds["keys"]) {
      let blockId = bIds["keys"][index];
      const b: MapClient<AnyBlock> = room.map(blockId);
      const retrievedBlock = b.toObject();
      if (retrievedBlock["type"] === "text") {
        allText += retrievedBlock["value"] + "\n";
      }
    }

    let a = document.createElement("a");
    let json = allText,
      blob = new Blob([json], { type: "octet/stream" }),
      url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = "exportedText.txt";
    a.click();
    window.URL.revokeObjectURL(url);
  };
  return <MenuItem onSelect={exportText}>Export space as text</MenuItem>;
}
